import { Dispatch, SetStateAction } from "react"

export const HandleToggleState = (setState: Dispatch<SetStateAction<boolean>>) => {
  setState(prevState => !prevState)
}
